import React from "react";
import { ListItem, ListItemIcon, ListItemText, List as MuiList, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

export const List = ({ list }) => {
  return (
    <MuiList>
      {list.map((item) => (
        <ListItem
          key={item}
          disablePadding
          sx={{
            alignItems: "flex-start",
          }}
        >
          <ListItemIcon sx={{ minWidth: "30px", pt: "0.5rem" }}>
            <FiberManualRecordIcon fontSize="inherit" color="primary" />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body1">{item}</Typography>} />
        </ListItem>
      ))}
    </MuiList>
  );
};
